"use client";

import { ErrorContent, type ErrorPageProps } from "@tosize/ui";
import { useEffect } from "react";
import { logError } from "~/lib/logError";

export default function DefaultError(props: ErrorPageProps) {
	useEffect(() => {
		logError({
			error: props.error,
			digest: props.error.digest,
			tags: { group: "default" },
		});
	}, [props.error]);

	return <ErrorContent {...props} />;
}
